export function normalizeGQLResponse(obj) {
    if (!obj || typeof obj !== "object") {
      return obj;
    }
  
    Object.keys(obj).forEach((key) => {
      if (["data", "node", "edges", "nodes"].includes(key)) {
        obj = normalizeGQLResponse(obj[key]);
      } else if (Array.isArray(obj[key])) {
        obj[key] = obj[key].map((inner) => normalizeGQLResponse(inner));
      } else {
        obj[key] = normalizeGQLResponse(obj[key]);
      }
    });
  
    return obj;
}